import { EDUCATION_SCOPE_KEY } from '../Education';

export default function educationScopeDirective() {
  return {
    restrict: 'A',
    link($scope, $element) {
      $element.data(EDUCATION_SCOPE_KEY, $scope);
    },
  };
}
